import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ProductionLineViewComponent } from "../../admin-production-line-management/production-line-view/production-line-view.component";

@Component({
  selector: "app-select-production-line",
  standalone: true,
  imports: [CommonModule, ProductionLineViewComponent],
  templateUrl: "./select-production-line.component.html",
  styleUrls: ["./select-production-line.component.scss"],
})
export class SelectProductionLineComponent {}
